(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login-react/assets/react/shared-components/iam-iframe-eid-app-handler.js') >= 0) return;  svs.modules.push('/modules/player-login-react/assets/react/shared-components/iam-iframe-eid-app-handler.js');

'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const IOS_IN_APP_BROWSER_MARKERS = svs.playerLoginReact.constants.IOS_IN_APP_BROWSER_MARKERS;
if (svs.accountservices.check_iam.isIamIFrameEnabled) {
  const updateQuerystringWithParams = (entriesObj, options) => {
    const url = new URL(window.location.href);
    Object.entries(entriesObj || {}).forEach(_ref => {
      let _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];
      if (value === undefined || value === null || value === '') {
        url.searchParams.delete(key);
      } else {
        url.searchParams.set(key, String(value));
      }
    });
    const state = {
      v: Date.now()
    };
    if (options && options.commit === 'push') {
      window.history.pushState(state, '', url.toString());
    } else {
      window.history.replaceState(state, '', url.toString());
    }
  };
  const isInAppWebView = userAgent => IOS_IN_APP_BROWSER_MARKERS.some(marker => userAgent.indexOf(marker) > -1);

  const isStandaloneSafari = userAgent => userAgent.indexOf('safari') > -1 && userAgent.indexOf('version/') > -1 && !isInAppWebView(userAgent);

  const handleIOS = () => {
    var _navigator, _svs;
    const userAgent = ((_navigator = navigator) === null || _navigator === void 0 || (_navigator = _navigator.userAgent) === null || _navigator === void 0 ? void 0 : _navigator.toLowerCase()) || '';
    const isNativeApp = (_svs = svs) === null || _svs === void 0 || (_svs = _svs.core) === null || _svs === void 0 || (_svs = _svs.config) === null || _svs === void 0 || (_svs = _svs.data) === null || _svs === void 0 || (_svs = _svs.svsconfig) === null || _svs === void 0 ? void 0 : _svs.isNativeApp;
    if (isNativeApp) {
      return encodeURIComponent(window.location.href.replace(/https?/i, 'spelbutiken.bankid'));
    } else if (userAgent.indexOf('firefox') > -1 || userAgent.indexOf('fxios') > -1) {
      return encodeURIComponent('firefox://');
    } else if (userAgent.indexOf('edgios') > -1 || userAgent.indexOf('edge') > -1 || userAgent.indexOf('edg/') > -1) {
      if (window.location.protocol.indexOf('s') > -1) {
        return 'microsoft-edge-https://';
      }
      return 'microsoft-edge-http://';
    } else if (isStandaloneSafari(userAgent)) {
      return encodeURIComponent(svs.utils.url.currentUrlEncodedParams());
    }
    return 'null'; 
  };

  const getReturnUrlForEidApp = function (serializedLoginObject) {
    let isBankId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    let returnUrl;
    updateQuerystringWithParams({
      iif: true,
      isBankId,
      slo: serializedLoginObject
    }, {
      commit: 'push'
    });
    if (svs.core.detect.browser.crios()) {
      if (window.location.protocol.indexOf('s') > -1) {
        returnUrl = 'googlechromes://';
      } else {
        returnUrl = 'googlechrome://';
      }
    } else if (svs.core.detect.os.iOS()) {
      returnUrl = handleIOS();
    } else {
      returnUrl = 'null';
    }
    return returnUrl;
  };
  svs.playerLoginReact.sharedComponents.iamIframeEidAppHandler = {
    getReturnUrlForEidApp
  };
}

 })(window);